import { Icon, Modal } from 'semantic-ui-react';
import React, {Component} from 'react'
import Single from '../../../componentes/Single'
import {Dropdown, Input} from 'semantic-ui-react'
import DateUtilities from '../../../componentes/DateUtilities'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';

class Agregar extends Component{
	constructor(props){
		super(props);
		this.newRegistro = this.newRegistro.bind(this);
		this.app= firebase;
		this.database = this.app.firestore().collection('Produccion');
		this.pagos=firebase.firestore().collection('Pagos')
		this.state = {
			useModal: false,
		}
	}

	newRegistro(data){
		this.database.add({
			submitDate: data.submitDate,
            fecha: data.fecha,
			variedad: data.variedad,
			sector: data.sector,
			empleado:data.empleado,
            fruta: data.fruta,
            totalCajas: Number(data.totalCajas),
			totalBotes: data.totalCajas*2
		})
		.then(()=>{
			if (!data.nomina || data.nomina==='tarea') {
				this.pagos.add({
					submitDate: data.submitDate,
					empleado:data.empleado,
					nombreActividad: "Piscar "+data.fruta,
					trabajoHecho: data.totalCajas*2,
					cajas6Precio: data.cajas6Precio,
					precio: data.precio,
					unidades: data.unidades,
					areaHecha: data.sector,
					numInvolucrados:1,
					estado:'Completado',
					fecha: data.fecha,
				})
			}
		})
		.catch(e=>{
			alert(e)
		})
	}
	modalAgregar = () => (
		<Modal 
			onClose={() => this.changeUsModal(false)}
			onOpen={() => this.changeUsModal(true)}
			open={this.state.useModal}
			trigger={<button><Icon name='plus' />Pisca</button>}>
			<Modal.Header>Ingresar Pisca</Modal.Header>
			<Modal.Content>
				<NuevoRegistro newRegistro={this.newRegistro} changeModal={this.changeUsModal} />
			</Modal.Content>
		</Modal>
	)
	changeUsModal=(open)=>{
		this.setState({useModal:open})
	}
	render(){
		return (
			<this.modalAgregar />
		);
	}
}

class NuevoRegistro extends Component{
	constructor(props){
		super(props);
        const today = new Date();
		this.state = {
			empleado:'',
			nombreActividad: '',
            totalCajas: 0,
			cajas6Precio: 0,
			precioMin: 0,
			precio: 0,
			unidades: "",
			submitDate: today,
            fecha: today,
			fechaStr: today.toISOString().split('T')[0],
			variedad: '',
			sector: 0,
            fruta:'',
			nomina:"tarea"
		}
		this.changeModal= this.props.changeModal
	}
	handleUserInput=(event)=>{
		if(event.target.name==='fecha'){
			const fecha=DateUtilities.parseDate(event.target.value)
			this.setState({
				fecha:fecha,
				fechaStr:event.target.value
			})
			return null
        }
		this.setState({
			[event.target.name]: event.target.value
		})
		//this.handleFrutaChange(e=()=>{this.state.fruta})
	}
	empleadoInput=(e, {value})=>{
        this.setState({empleado:value})
    }
	nominaInput=(e, {value})=>{
		if (value==="hora"){
			this.setState({nomina:"hora", precio:0})
		} else{
			this.setState({nomina:"tarea", 
			precio:(this.state.precioMin+this.state.cajas6Precio) * this.state.totalCajas
		})
		}
    }
    sectorInput= async (e, {value})=>{
		const data =  firebase.firestore().collection('Zonas')
        const filtro = data.where('sector', '==', value)
		const variedad = await filtro.get()
		if (variedad.empty) {
			this.setState({
				sector:value,
				variedad:''
			})
		}
		variedad.forEach(doc => {
		this.setState({
			sector:value,
			variedad:doc.data().variedad
		})
		})
    }
    handleFrutaChange= async (e, {value})=>{
		const data =  firebase.firestore().collection('Actividades')
        const filtro = data.where('nombre', '==', "Piscar "+value)
		const precio = await filtro.get()
		let nomina = 0
		if (this.state.nomina === "tarea"){
			nomina = 1
		}
		if (precio.empty) {
			alert("Ingrese el precio de "+"Piscar "+value+"en la pagina de Actividades")
		} else{
			precio.forEach(doc =>{
				if (doc.data().nombre === 'Piscar Zarzamora'){
					this.setState({
						cajas6Precio: doc.data().caja6[0]/4,
						precioMin: 0,
						precio: (doc.data().caja6[0]/4) * nomina
					})
				}else{
					this.setState({
						precioMin: doc.data().precioMin,
						cajas6Precio: 0,
						precio: doc.data().precioMin * nomina
					})
				}
			})
		}
        this.setState({fruta:value})
		if (value === "Zarzamora"){
			this.setState({unidades:"medios botes"})
		} else {
			this.setState({unidades:"botes"})
		}
    }

	writeNew=(event)=>{
		event.preventDefault()
		if (!this.state.empleado || !this.state.sector || this.state.fruta === ""){
			alert("Llene todos los campos.")
			return
		}
        const data = {...this.state};
		this.props.newRegistro(data);
		this.setState({
			variedad: '',
			sector: '',
            fruta:'',
            totalCajas: 0,
		})
		this.changeModal(false)
	}

	render(){
		return(
			<div>
				<form onSubmit={this.writeNew}>
					<label>Fecha: </label>
					<Input type='date' name='fecha' required={true} 
						onChange={this.handleUserInput} value={this.state.fechaStr} 
					/>
					<Single tabla='Empleados' columna='Nombre'
						required={true}
						filtro1='activo' filtro2='==' filtro3='si' 
						value={this.state.empleado} onChange={this.empleadoInput}
						placeholder='empleado' 
					/>
					<div className="input">Fruta: 
                    	<Dropdown
							required={true}
                            fluid
                            selection
                            options={[
                                {key:1, text:'Frambuesa', value:'Frambuesa'},
                                {key:2, text:'Zarzamora', value:'Zarzamora'},
                            ]}
                            name='fruta'
                            value={this.state.fruta}
                            onChange={this.handleFrutaChange}
                        />
                    </div>
					<div className="input">Sector: 
                        <Single 
							required={true}
                            tabla='Zonas'
                            columna='sector'
                            placeholder='sector' 
                            value={this.state.sector}
                            onChange={this.sectorInput} 
                        />
                    </div>
                    <div className="input">
						{this.state.fruta === "Zarzamora"?<>Medios Botes</>:<>Botes</>} 
					<input type='int' 
					name='totalCajas' required={true} onChange={this.handleUserInput}/></div>
					<p>Pagar por</p>
					<Dropdown
						required={true}
						fluid
						selection
						onChange={this.nominaInput}
						value={this.state.nomina}
						options={[{ key: 1, value: 'tarea', text: 'Tarea' }, { key: 2, value: 'hora', text: 'Dia' }]}
					/>
					<p>A pagar</p>
					<Input value={this.state.precio*this.state.totalCajas} disabled />
					<p><button type="submit">Guardar</button></p>
				</form>

			</div>
		)
	}
}
export default Agregar
